import type { AxiosInstance } from "axios";
import {
  EventIdPublic,
  UserIdPublic,
} from "@shared/schemas/branded-id.schemas";
import type {
  EventHost,
  RemoveEventHostResult,
} from "@shared/schemas/event-host.schemas";
import type { AddEventHostBody } from "@shared/schemas/event-host-write.schemas";

const basePath = (eventIdPublic: EventIdPublic): string =>
  `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/hosts`;

export function createEventHostsApi(apiClient: AxiosInstance) {
  return {
    async getByEvent(eventIdPublic: EventIdPublic): Promise<EventHost[]> {
      const response = await apiClient.get<EventHost[]>(
        basePath(eventIdPublic),
      );
      return response.data;
    },

    async add(
      eventIdPublic: EventIdPublic,
      body: AddEventHostBody,
    ): Promise<EventHost> {
      const response = await apiClient.post<EventHost>(
        basePath(eventIdPublic),
        body,
      );
      return response.data;
    },

    async remove(
      eventIdPublic: EventIdPublic,
      userIdPublic: UserIdPublic,
    ): Promise<RemoveEventHostResult> {
      const response = await apiClient.delete<RemoveEventHostResult>(
        `${basePath(eventIdPublic)}/${encodeURIComponent(UserIdPublic.unwrap(userIdPublic))}`,
      );
      return response.data;
    },
  };
}
